import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';

export default function WaitlistThankYouPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar isPublic={true} />
      
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white shadow rounded-lg p-8 text-center">
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100 mb-4">
            <svg className="h-6 w-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          
          <h1 className="text-3xl font-bold text-gray-900 mb-4">You're on the list!</h1>
          
          <p className="text-lg text-gray-600 mb-6">
            Thank you for joining the FlowDocs waitlist. We'll notify you as soon as we open to the public!
          </p>
          
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mb-8">
            <h2 className="text-lg font-semibold text-blue-900 mb-2">What happens next?</h2>
            <p className="text-blue-800 mb-4">
              You'll be among the first to know when FlowDocs launches publicly.
            </p>
            <p className="text-blue-800 font-semibold">
              As an early supporter, you'll receive an exclusive discount on your first subscription!
            </p>
          </div>
          
          <div className="space-y-4">
            <p className="text-gray-600">
              Want to jump ahead? Apply for our customer test program to get early access.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/customer-test"
                className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700"
              >
                Apply for Early Access
              </Link>
              
              <Link
                to="/"
                className="inline-flex items-center justify-center px-5 py-3 border border-gray-300 text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
              >
                Return to Home
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}